import httpService from "services/httpService";

const baseApiEndPoint = process.env.REACT_APP_API_ENDPOINT;

const apiEndPoint = baseApiEndPoint + "/billingGroup";

export async function fetch(id) {
  const { data } = await httpService.get(apiEndPoint + "/" + id);
  return data;
}

export async function update(model) {
  const { data } = await httpService.put(apiEndPoint + "/" + model.id, {
    ...model,
  });
  return data;
}

export async function create(model) {
  const { data } = await httpService.post(apiEndPoint, {
    ...model,
  });
  return data;
}

export async function fetchBillingGroup() {
  const { data } = await httpService.get(apiEndPoint + "/");
  return data;
}

export async function fetchAll(queryString = "") {
  queryString = queryString ? `?condition=${encodeURI(queryString)}` : "";
  const { data } = await httpService.get(apiEndPoint + "/all" + queryString);
  return data;
}

export default {
  create,
  update,
  fetchBillingGroup,
  fetchAll,
};
